const Outros = () => {

return (

<div>

<h1>Outros</h1>

</div>

)

}

export default Outros
